import store from '@/store';
import findTripFromAllSearches from 'utils/trips/findTripFromAllSearches';
import { showTripDetailsTracker } from 'metrics/user-analytics/trip';
import reportsFinalPrice from 'utils/trips/reportsFinalPrice';
import { connect } from 'react-redux';
import { getTripDetails } from '@/actions/trip';
import DetailsButton from './DetailsButton';

const mapStateToProps = (state, ownProps) => {
  const { tripsDetails } = state;
  const { tripId } = ownProps;
  const loadingTripId = tripsDetails.get('loadingTripId');

  return {
    isLoading: tripId === loadingTripId,
    isDisabled: Boolean(loadingTripId),
  };
};

const mapDispatchToProps = (dispatch) => ({
  showDetails(tripId, position) {
    const { trips } = store.getState();
    const { trip } = findTripFromAllSearches(trips, tripId);
    const tripJS = trip.toJS();
    // BOOK-168: `Price` is read from this trip's `pricing`, so the arm is resolved on it, at the
    // click, with the same rule and tab latch as its card.
    const isFinal = reportsFinalPrice([tripJS]);
    showTripDetailsTracker(tripJS, position, isFinal);
    dispatch(getTripDetails(tripId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DetailsButton);
